module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.2106/img/callout-blobs.svg"